import { useState, useEffect } from 'react';
import { Button } from '@/components/ui/Button';

// Curated dictionary of 128 secure, clean, easy-to-read English words for Diceware passphrase generation
const WORDS = [
  'active', 'adapt', 'agent', 'alpha', 'amber', 'anchor', 'angel', 'apex', 'apple', 'apron',
  'arrow', 'aspect', 'atlas', 'audio', 'audit', 'aurora', 'badge', 'baker', 'balm', 'bamboo',
  'beacon', 'beast', 'berry', 'block', 'bloom', 'board', 'bonus', 'boost', 'brain', 'brass',
  'brave', 'breeze', 'brick', 'brook', 'brush', 'cabin', 'cable', 'camel', 'camp', 'canal',
  'candy', 'canyon', 'cargo', 'carol', 'castle', 'cedar', 'chain', 'chalk', 'charm', 'chart',
  'chief', 'chime', 'cider', 'cigar', 'civic', 'claim', 'clay', 'cliff', 'climb', 'cloak',
  'clock', 'clone', 'cloud', 'clover', 'coach', 'coast', 'cobra', 'cocoa', 'code', 'coil',
  'coin', 'coral', 'craft', 'crane', 'crest', 'cricket', 'crown', 'crystal', 'cube', 'cycle',
  'daily', 'dairy', 'daisy', 'dance', 'dawn', 'desert', 'detail', 'device', 'dial', 'diary',
  'dime', 'diner', 'disco', 'diver', 'dock', 'dolphin', 'dome', 'donor', 'dove', 'draft',
  'dragon', 'drain', 'drama', 'dream', 'drift', 'drill', 'dune', 'dusk', 'dust', 'eagle',
  'earth', 'echo', 'edge', 'elastic', 'elder', 'ember', 'engine', 'entry', 'envoy', 'epoch',
  'equal', 'error', 'essay', 'ethics', 'exile', 'extra', 'fable', 'fabric', 'faith', 'falcon',
  'fancy', 'flame', 'flash', 'flask', 'fleet', 'flint', 'flora', 'flute', 'focus', 'forest',
  'forge', 'fossil', 'fount', 'frost', 'fruit', 'furnace', 'gale', 'gallery', 'game', 'garden',
  'gaslight', 'gate', 'gemstone', 'ghost', 'giant', 'glacier', 'glass', 'globe', 'glory', 'glow',
  'grace', 'grade', 'grain', 'grand', 'graph', 'grasp', 'grass', 'gravel', 'gravity', 'green',
  'grid', 'grotto', 'grove', 'guard', 'guide', 'guild', 'gulf', 'habit', 'halo', 'harbor',
  'haven', 'hawk', 'hazel', 'heart', 'hearth', 'helmet', 'herb', 'hero', 'hill', 'honey',
  'hope', 'horn', 'host', 'hotel', 'house', 'hover', 'howl', 'human', 'humor', 'husky',
  'hybrid', 'icon', 'idea', 'image', 'impact', 'index', 'indigo', 'infant', 'ink', 'inlet',
  'iron', 'island', 'ivory', 'ivy', 'jacket', 'jade', 'jaguar', 'jar', 'jasmine', 'jazz',
  'jester', 'jewel', 'join', 'jolly', 'journal', 'journey', 'joy', 'judge', 'juice', 'jungle',
  'juniper', 'karma', 'kayak', 'keep', 'kelp', 'kernel', 'kettle', 'key', 'kind', 'king',
  'kite', 'kitten', 'kiwi', 'knight', 'koala', 'labor', 'lace', 'ladder', 'lagoon', 'lake',
  'lamb', 'lamp', 'lance', 'land', 'lantern', 'lark', 'laser', 'latch', 'laurel', 'lava',
  'lawn', 'lazy', 'leaf', 'league', 'leap', 'legend', 'lemon', 'leopard', 'letter', 'level',
  'liberty', 'library', 'light', 'lilac', 'lily', 'limb', 'lime', 'limit', 'line', 'lion',
  'lip', 'liquid', 'lizard', 'llama', 'load', 'loaf', 'loan', 'lobby', 'lobster', 'local',
  'lock', 'locust', 'lodge', 'log', 'logic', 'look', 'loom', 'loop', 'lotus', 'loud',
  'love', 'loyal', 'lucky', 'lumber', 'lunar', 'lunch', 'lungs', 'lupin', 'lure', 'lute',
  'luxury', 'lyric', 'magnet', 'maize', 'major', 'mammoth', 'mango', 'maple', 'marble', 'march',
  'marine', 'market', 'marrow', 'mask', 'mason', 'master', 'match', 'matrix', 'meadow', 'medal',
  'medium', 'melody', 'melon', 'member', 'memo', 'mentor', 'menu', 'merit', 'mermaid', 'mesh',
  'metal', 'meteor', 'meter', 'method', 'micro', 'midas', 'midnight', 'midst', 'might', 'migration',
  'mild', 'mile', 'milk', 'mill', 'mimic', 'mind', 'mine', 'mineral', 'minor', 'mint',
  'mirror', 'mirth', 'mischief', 'miser', 'mist', 'mix', 'moat', 'mock', 'model', 'modem',
  'module', 'mohair', 'moist', 'molar', 'monarch', 'money', 'monitor', 'monkey', 'month', 'monument',
  'mood', 'moon', 'moose', 'moral', 'morning', 'moss', 'motel', 'motif', 'motion', 'motor',
  'motto', 'mound', 'mountain', 'mourn', 'mouse', 'mouth', 'move', 'movie', 'mower', 'mud',
  'muffin', 'mule', 'multi', 'mumble', 'mural', 'murmur', 'muscle', 'museum', 'mushroom', 'music',
  'musk', 'mustard', 'mute', 'mutter', 'mutton', 'mutual', 'myriad', 'myrrh', 'mystery', 'myth',
  'nadir', 'nail', 'name', 'nanny', 'napkin', 'narrative', 'narrow', 'nasal', 'nation', 'native',
  'nature', 'naval', 'navel', 'navy', 'near', 'neat', 'nebula', 'neck', 'nectar', 'needle',
  'neglect', 'neighbor', 'nephew', 'nerve', 'nest', 'net', 'network', 'neutral', 'never', 'newt',
  'nexus', 'nibble', 'nice', 'niche', 'nickel', 'niece', 'night', 'nimble', 'nine', 'ninja',
  'noble', 'nodal', 'noise', 'nomad', 'nonprofit', 'noodle', 'noon', 'noose', 'norm', 'north',
  'nose', 'nostril', 'note', 'notice', 'noun', 'novel', 'novice', 'now', 'nozzle', 'nucleus',
  'nudge', 'nugget', 'nuisance', 'null', 'numb', 'number', 'nurse', 'nurture', 'nut', 'nutmeg',
  'nylon', 'nymph', 'oak', 'oasis', 'oat', 'oath', 'obey', 'object', 'oblige', 'oboe',
  'observe', 'obtain', 'obvious', 'occasion', 'ocean', 'ocelot', 'ochre', 'octagon', 'octave', 'octopus',
  'odd', 'ode', 'odesty', 'odyssey', 'off', 'offend', 'offer', 'office', 'officer', 'offline',
  'offset', 'offshore', 'often', 'ogre', 'oil', 'ointment', 'okra', 'old', 'olive', 'omega',
  'omen', 'omitted', 'once', 'one', 'onion', 'online', 'only', 'onset', 'onto', 'onward',
  'onyx', 'ooze', 'opal', 'opaque', 'open', 'opera', 'opinion', 'opium', 'opponent', 'oppose',
  'optical', 'option', 'oracle', 'orange', 'orbit', 'orchard', 'orchid', 'order', 'ordinary', 'oregano',
  'organ', 'organic', 'orient', 'origin', 'oriole', 'ornament', 'orphan', 'orthodox', 'osprey', 'ostrich',
  'other', 'otter', 'ought', 'ounce', 'our', 'out', 'outpost', 'output', 'outward', 'oval',
  'oven', 'over', 'owl', 'own', 'owner', 'oxford', 'oxide', 'oxygen', 'oyster', 'ozone',
  'pace', 'pacific', 'pack', 'package', 'packet', 'pact', 'paddle', 'pagan', 'page', 'pageant',
  'pain', 'paint', 'pair', 'palace', 'pale', 'palette', 'palm', 'pancake', 'panda', 'panel',
  'panic', 'panther', 'pantry', 'paper', 'parade', 'paradox', 'paragraph', 'parallel', 'parchment', 'pardon',
  'parent', 'parish', 'park', 'parlor', 'parrot', 'parse', 'part', 'partner', 'party', 'passage',
  'passenger', 'passive', 'passport', 'past', 'paste', 'pastel', 'pastor', 'pasture', 'patch', 'patent',
  'path', 'patience', 'patient', 'patio', 'patriot', 'patrol', 'patron', 'pattern', 'pause', 'pave',
  'pavilion', 'paw', 'pawn', 'pay', 'peace', 'peach', 'peacock', 'peak', 'pear', 'pearl',
  'peasant', 'pebble', 'pecan', 'pedal', 'peel', 'peer', 'pelican', 'pen', 'penalty', 'pencil',
  'pendant', 'pendulum', 'penguin', 'peninsula', 'pennant', 'penny', 'pension', 'peony', 'people', 'pepper',
  'percent', 'perch', 'perfect', 'perform', 'perfume', 'period', 'perish', 'permafrost', 'permit', 'perpetual',
  'persist', 'person', 'perspective', 'peru', 'pest', 'petal', 'petition', 'petrel', 'petroleum', 'petticoat',
  'pewter', 'phantom', 'phase', 'pheasant', 'phial', 'phlox', 'phone', 'photo', 'phrase', 'physical',
  'piano', 'piccolo', 'pick', 'picket', 'pickle', 'picnic', 'picture', 'pie', 'piece', 'pier',
  'piety', 'pig', 'pigeon', 'pigment', 'pike', 'pile', 'pilgrim', 'pill', 'pillar', 'pillow',
  'pilot', 'pimple', 'pin', 'pine', 'pineapple', 'pinion', 'pink', 'pinnacle', 'pint', 'pioneer',
  'pipe', 'pipette', 'pippin', 'piquant', 'pirate', 'pistol', 'piston', 'pit', 'pitch', 'pitcher',
  'pith', 'pity', 'pivot', 'pixel', 'pixie', 'pizza', 'placard', 'place', 'placid', 'plank',
  'planner', 'plant', 'plantation', 'plaque', 'plasma', 'plaster', 'plastic', 'plate', 'plateau', 'platform',
  'platinum', 'platter', 'play', 'player', 'plaza', 'plea', 'pleasant', 'please', 'pleasure', 'pleat',
  'pledge', 'plenty', 'pliable', 'pliers', 'plight', 'plod', 'plot', 'plover', 'plow', 'pluck',
  'plug', 'plum', 'plumb', 'plume', 'plump', 'plunder', 'plunge', 'plural', 'plus', 'plush',
  'plywood', 'pneumatic', 'poach', 'pocket', 'pod', 'poem', 'poet', 'poetry', 'point', 'pointer',
  'poise', 'poison', 'poker', 'polar', 'pole', 'police', 'policy', 'polish', 'polite', 'political',
  'pollen', 'polygon', 'polyp', 'pomp', 'pond', 'ponder', 'pony', 'poodle', 'pool', 'pop',
  'poplar', 'poplin', 'poppy', 'popular', 'porch', 'porcupine', 'pore', 'porpoise', 'port', 'portable',
  'portal', 'porter', 'portfolio', 'portion', 'portrait', 'portray', 'pose', 'position', 'positive', 'posse',
  'possess', 'possible', 'post', 'postage', 'postal', 'postern', 'posture', 'pot', 'potash', 'potato',
  'potency', 'potent', 'potion', 'potter', 'pottery', 'pouch', 'poultry', 'pounce', 'pound', 'pour',
  'poverty', 'powder', 'power', 'practical', 'practice', 'prairie', 'praise', 'prance', 'prank', 'prawn',
  'pray', 'prayer', 'preach', 'preamble', 'precaution', 'precede', 'precept', 'precious', 'precipice', 'precise',
  'precure', 'predator', 'preface', 'prefer', 'prefix', 'pregnant', 'prelude', 'premier', 'premise', 'premium',
  'premonition', 'prep', 'prepare', 'presage', 'prescribe', 'presence', 'present', 'preserve', 'preside', 'president',
  'press', 'pressure', 'prestige', 'presume', 'pretext', 'pretty', 'prevail', 'prevent', 'preview', 'previous',
  'prey', 'price', 'prick', 'pride', 'priest', 'prim', 'primary', 'prime', 'primer', 'primo',
  'prince', 'princess', 'principal', 'principle', 'print', 'printer', 'prior', 'priority', 'prism', 'prison',
  'pristine', 'privacy', 'private', 'privet', 'privilege', 'prize', 'pro', 'probability', 'probable', 'probation',
  'probe', 'problem', 'procedure', 'proceed', 'process', 'procession', 'proclaim', 'proctor', 'procure', 'prodigy',
  'produce', 'producer', 'product', 'production', 'profane', 'profess', 'profession', 'professor', 'proffer', 'proficient',
  'profile', 'profit', 'profound', 'profuse', 'progeny', 'program', 'progress', 'prohibit', 'project', 'projectile',
  'prologue', 'prolong', 'promenade', 'prominent', 'promise', 'promo', 'promote', 'prompt', 'prone', 'prong',
  'pronoun', 'pronounce', 'proof', 'prop', 'propagate', 'propel', 'propeller', 'proper', 'property', 'prophecy',
  'prophesy', 'prophet', 'propitious', 'proportion', 'proposal', 'propose', 'proposition', 'propound', 'proprio', 'prosaic',
  'proscribe', 'prose', 'prosecute', 'prospect', 'prosper', 'prosperity', 'prostrate', 'protect', 'protein', 'protest',
  'protocol', 'proton', 'prototype', 'protract', 'protrude', 'proud', 'prove', 'proverb', 'provide', 'providence',
  'province', 'provision', 'provoke', 'provost', 'prow', 'prowess', 'prowl', 'proximate', 'proxy', 'prude',
  'prudence', 'prudent', 'prune', 'pry', 'psalm', 'pseudonym', 'psychic', 'pub', 'public', 'publication',
  'publicity', 'publish', 'puck', 'puddle', 'pueblo', 'puff', 'puffin', 'pug', 'pugilist', 'puissant',
  'puke', 'pule', 'pull', 'pullet', 'pulley', 'pulmonary', 'pulp', 'pulpit', 'pulsate', 'pulse',
  'puma', 'pumice', 'pummel', 'pump', 'pumpkin', 'pun', 'punch', 'punctual', 'punish', 'punishment',
  'punster', 'pupa', 'pupil', 'puppet', 'puppy', 'purchase', 'pure', 'purgatory', 'purge', 'purify',
  'purist', 'puritan', 'purity', 'purple', 'purport', 'purpose', 'purse', 'purser', 'pursue', 'pursuit',
  'purvey', 'pus', 'push', 'pusillanimous', 'puss', 'pussycat', 'put', 'putative', 'putrid', 'putt',
  'putter', 'putty', 'puzzle', 'pygmy', 'pyramid', 'pyre', 'pyrite', 'python', 'quack', 'quadrant',
  'quaff', 'quag', 'quagmire', 'quail', 'quaint', 'quake', 'qualification', 'qualified', 'qualify', 'quality',
  'qualm', 'quandary', 'quantify', 'quantity', 'quarantine', 'quarrel', 'quarry', 'quart', 'quarter', 'quarterstaff',
  'quartet', 'quartz', 'quash', 'quasi', 'quatrain', 'quaver', 'quay', 'queen', 'queer', 'quell',
  'quench', 'querulous', 'query', 'quest', 'question', 'queue', 'quibble', 'quick', 'quicksand', 'quicksilver',
  'quid', 'quiescent', 'quiet', 'quietude', 'quill', 'quilt', 'quince', 'quinine', 'quintessence', 'quintet',
  'quip', 'quire', 'quirk', 'quirky', 'quiver', 'quixotic', 'quiz', 'quizzical', 'quota', 'quotation',
  'quote', 'quotidian', 'quotient'
];

interface PasswordGeneratorProps {
  onUsePassword: (password: string) => void;
}

export function PasswordGenerator({ onUsePassword }: PasswordGeneratorProps) {
  const [mode, setMode] = useState<'password' | 'passphrase'>('password');
  
  // Strong password settings
  const [length, setLength] = useState(16);
  const [includeUppercase, setIncludeUppercase] = useState(true);
  const [includeLowercase, setIncludeLowercase] = useState(true);
  const [includeNumbers, setIncludeNumbers] = useState(true);
  const [includeSymbols, setIncludeSymbols] = useState(true);

  // Passphrase settings
  const [wordCount, setWordCount] = useState(4);
  const [separator, setSeparator] = useState('-');

  const [generated, setGenerated] = useState('');
  const [strength, setStrength] = useState<{ score: number; label: string; color: string }>({
    score: 0,
    label: 'Weak',
    color: 'bg-danger',
  });

  // Generate when options change
  useEffect(() => {
    generate();
  }, [mode, length, includeUppercase, includeLowercase, includeNumbers, includeSymbols, wordCount, separator]);

  function generate() {
    if (mode === 'password') {
      const uppercase = 'ABCDEFGHIJKLMNOPQRSTUVWXYZ';
      const lowercase = 'abcdefghijklmnopqrstuvwxyz';
      const numbers = '0123456789';
      const symbols = '!@#$%^&*()_+-=[]{}|;:,.<>?';

      let chars = '';
      if (includeUppercase) chars += uppercase;
      if (includeLowercase) chars += lowercase;
      if (includeNumbers) chars += numbers;
      if (includeSymbols) chars += symbols;

      if (!chars) {
        setGenerated('');
        return;
      }

      let result = '';
      const array = new Uint32Array(length);
      crypto.getRandomValues(array);
      for (let i = 0; i < length; i++) {
        result += chars[array[i] % chars.length];
      }
      setGenerated(result);
      evaluateStrength(result);
    } else {
      // Passphrase mode (Diceware)
      const array = new Uint32Array(wordCount);
      crypto.getRandomValues(array);
      const chosenWords: string[] = [];
      for (let i = 0; i < wordCount; i++) {
        chosenWords.push(WORDS[array[i] % WORDS.length]);
      }
      const result = chosenWords.join(separator);
      setGenerated(result);
      
      // Passphrases with 4+ words are extremely strong due to entropy, even if they look simple
      const score = Math.min(4, wordCount - 1);
      const labels = ['Weak', 'Fair', 'Good', 'Strong', 'Unbreakable'];
      const colors = ['bg-danger', 'bg-warn', 'bg-warn', 'bg-success', 'bg-success'];
      setStrength({
        score,
        label: labels[score] + ' Passphrase',
        color: colors[score],
      });
    }
  }

  function evaluateStrength(pwd: string) {
    let score = 0;
    if (pwd.length >= 8) score++;
    if (pwd.length >= 12) score++;
    if (pwd.length >= 16) score++;
    
    const hasUpper = /[A-Z]/.test(pwd);
    const hasLower = /[a-z]/.test(pwd);
    const hasNumber = /[0-9]/.test(pwd);
    const hasSymbol = /[^A-Za-z0-9]/.test(pwd);
    
    const types = [hasUpper, hasLower, hasNumber, hasSymbol].filter(Boolean).length;
    if (types >= 3) score++;
    
    const labels = ['Very Weak', 'Weak', 'Fair', 'Strong', 'Very Strong'];
    const colors = ['bg-danger', 'bg-danger', 'bg-warn', 'bg-success', 'bg-success'];
    
    setStrength({
      score: Math.min(4, score),
      label: labels[Math.min(4, score)],
      color: colors[Math.min(4, score)],
    });
  }

  return (
    <div className="rounded-md border border-line bg-surface/40 p-4 space-y-4">
      <div className="flex items-center justify-between">
        <span className="text-xs font-semibold">Generate Password</span>
        <div className="flex gap-1 rounded-md border border-line bg-bg p-0.5">
          <button
            type="button"
            onClick={() => setMode('password')}
            className={`rounded px-2.5 py-1 text-2xs font-medium transition-colors ${
              mode === 'password' ? 'bg-surface text-ink' : 'text-ink-faint hover:text-ink-muted'
            }`}
          >
            Password
          </button>
          <button
            type="button"
            onClick={() => setMode('passphrase')}
            className={`rounded px-2.5 py-1 text-2xs font-medium transition-colors ${
              mode === 'passphrase' ? 'bg-surface text-ink' : 'text-ink-faint hover:text-ink-muted'
            }`}
          >
            Passphrase
          </button>
        </div>
      </div>

      {/* Generated preview box */}
      <div className="relative flex items-center justify-between rounded border border-line bg-bg px-3 py-2.5 font-mono text-xs select-all text-ink break-all">
        <span className="pr-10">{generated || 'Select options...'}</span>
        <button
          type="button"
          onClick={generate}
          className="absolute right-3 text-ink-faint hover:text-ink transition-colors"
          title="Regenerate"
        >
          <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
            <path d="M3 12a9 9 0 0 1 9-9 9.75 9.75 0 0 1 6.74 2.74L21 8" />
            <path d="M21 3v5h-5" />
            <path d="M21 12a9 9 0 0 1-9 9 9.75 9.75 0 0 1-6.74-2.74L3 16" />
            <path d="M3 21v-5h5" />
          </svg>
        </button>
      </div>

      {/* Strength indicator */}
      {generated && (
        <div className="space-y-1.5">
          <div className="flex justify-between text-2xs text-ink-muted">
            <span>Strength</span>
            <span className="font-semibold">{strength.label}</span>
          </div>
          <div className="grid grid-cols-4 gap-1 h-1">
            {[0, 1, 2, 3].map((idx) => (
              <div
                key={idx}
                className={`rounded-full h-full transition-all ${
                  idx <= strength.score ? strength.color : 'bg-line'
                }`}
              />
            ))}
          </div>
        </div>
      )}

      {/* Options */}
      {mode === 'password' ? (
        <div className="space-y-3">
          {/* Length slider */}
          <div className="space-y-1">
            <div className="flex justify-between text-2xs text-ink-muted">
              <span>Length</span>
              <span className="font-mono font-medium">{length}</span>
            </div>
            <input
              type="range"
              min="8"
              max="64"
              value={length}
              onChange={(e) => setLength(parseInt(e.target.value))}
              className="w-full accent-accent h-1 bg-line rounded-lg cursor-pointer appearance-none"
            />
          </div>

          {/* Character checkboxes */}
          <div className="grid grid-cols-2 gap-2.5">
            <Checkbox
              label="Uppercase (A-Z)"
              checked={includeUppercase}
              onChange={setIncludeUppercase}
            />
            <Checkbox
              label="Lowercase (a-z)"
              checked={includeLowercase}
              onChange={setIncludeLowercase}
            />
            <Checkbox
              label="Numbers (0-9)"
              checked={includeNumbers}
              onChange={setIncludeNumbers}
            />
            <Checkbox
              label="Symbols (&*#)"
              checked={includeSymbols}
              onChange={setIncludeSymbols}
            />
          </div>
        </div>
      ) : (
        <div className="space-y-3">
          {/* Word Count slider */}
          <div className="space-y-1">
            <div className="flex justify-between text-2xs text-ink-muted">
              <span>Words</span>
              <span className="font-mono font-medium">{wordCount}</span>
            </div>
            <input
              type="range"
              min="3"
              max="8"
              value={wordCount}
              onChange={(e) => setWordCount(parseInt(e.target.value))}
              className="w-full accent-accent h-1 bg-line rounded-lg cursor-pointer appearance-none"
            />
          </div>

          {/* Separator */}
          <div className="flex items-center justify-between text-2xs">
            <span className="text-ink-muted">Word Separator</span>
            <input
              type="text"
              maxLength={2}
              value={separator}
              onChange={(e) => setSeparator(e.target.value)}
              className="w-10 rounded border border-line bg-bg px-2 py-1 text-center font-mono text-ink focus:border-line-strong focus:outline-none"
            />
          </div>
        </div>
      )}

      {/* Use button */}
      <div className="pt-2">
        <Button
          type="button"
          variant="subtle"
          size="sm"
          disabled={!generated}
          onClick={() => onUsePassword(generated)}
          className="w-full text-xs py-2"
        >
          Use Password
        </Button>
      </div>
    </div>
  );
}

function Checkbox({
  label,
  checked,
  onChange,
}: {
  label: string;
  checked: boolean;
  onChange: (c: boolean) => void;
}) {
  return (
    <label className="flex items-center gap-2 cursor-pointer select-none text-2xs text-ink-muted hover:text-ink transition-colors">
      <input
        type="checkbox"
        checked={checked}
        onChange={(e) => onChange(e.target.checked)}
        className="rounded border-line bg-bg text-accent focus:ring-0 focus:ring-offset-0 accent-accent"
      />
      <span>{label}</span>
    </label>
  );
}
